import { ExternalPaths, Paths } from '@shared/menu-items/paths'

export const data = {
	heading: 'Развиваем три ключевых направления',
	directions: [
		{
			company: 'Credit.Club',
			name: 'Кредиты',
			color: 'blue',
			content: [
				'Выдаём технологичные кредиты и займы: наши клиенты быстро получают деньги по рыночной ставке из приложения и оформляют сделки онлайн.',
				'Мы создаём бесшовный комфортный опыт решения финансового вопроса в один клик.',
			],
		},
		{
			company: 'Credit.Club',
			name: 'Технологии',
			color: 'green',
			content: [
				'Разрабатываем сервисы и приложения, которые помогают банкам и другим финансовым компаниям переводить процессы в онлайн, автоматизировать работу с клиентами, масштабировать бизнес без привязки к офисам и повышать эффективность бизнеса.',
				'Создаём и сопровождаем технологичные процессы.',
			],
		},
		{
			company: 'Credit.Club',
			name: 'Инвестиции',
			color: 'grey',
			content: [
				'Делаем рынок инвестиций в залоговые займы удобным, доступным и безопасным для любого участника. Для этого разрабатываем и запускаем продукты, которые не требуют экспертизы от инвестора, не отнимают время, но отличаются повышенной надёжностью и высокой доходностью.',
			],
		},
	],

	advantages: [
		{
			text: 'Получить деньги',
			href: Paths.root,
			img: 'money.png',
			color: 'blue',
		},
		{
			text: 'Автоматизировать бизнес',
			href: ExternalPaths.banks,
			img: 'business.png',
			color: 'green',
		},
		{
			text: 'Сделать сбережение',
			href: Paths.investorsFond,
			img: 'rouble-icon.png',
			color: 'grey',
		},
	],
}
